import { List } from 'immutable';
import { useSelector } from 'react-redux';
import { selectCardsById } from './selectors';

/**
 * The names of cards the game refers to by id, like the Trainers attached to a Pokémon. What a card is comes from
 * the catalog only; the game says which cards.
 *
 * @param {List|undefined} cardIds
 * @returns {List<string>}
 */
export default function useCardNames(cardIds) {
  const cardsById = useSelector(selectCardsById);

  return (cardIds || List()).map(id => cardsById.getIn([id, 'name'], 'a card'));
}
